import { DoorOpen, Inbox, Phone } from "lucide-react"
import { h2Class } from "../lightTheme"
import { notForContent } from "./notForContent"

const labelIcons = [Inbox, Phone, DoorOpen]

const cardClass =
  "flex rounded-[2px] border border-solid border-[#E6E6E6] transition-colors hover:border-[#8F8F8F]"

export default function NotForSection() {
  return (
    <section className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-col gap-12 lg:gap-[72px]">
      <div className="grid w-full grid-cols-1 items-end gap-6 lg:grid-cols-12">
        <h2
          className={`${h2Class} text-balance max-md:text-[32px] max-md:leading-10 max-md:tracking-[-0.04em] lg:col-span-7`}
        >
          {notForContent.title}
        </h2>
        <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D] lg:col-span-5 lg:text-right">
          {notForContent.body}
        </p>
      </div>
      <ul className="m-0 grid w-full list-none grid-cols-1 gap-6 p-0 lg:grid-cols-3">
        {notForContent.items.map((item, index) => {
          const Icon = labelIcons[index]
          return (
            <li key={item.title} className={cardClass}>
              <div className="flex h-full w-full flex-col gap-4 p-6">
                <p className="flex items-center gap-3 text-[14px] font-bold leading-5 text-[#171717]">
                  <Icon className="size-4 shrink-0" strokeWidth={1.5} aria-hidden="true" />
                  {item.label}
                </p>
                <h3 className="min-h-24 text-balance text-[24px] font-bold leading-8 tracking-[-0.04em] text-[#171717]">
                  {item.title}
                </h3>
                <p className="mt-auto text-pretty text-[14px] font-normal leading-5 text-[#171717]">
                  {item.detail}
                </p>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
